import { useReferenceStore } from "@app/store/useReferenceStore";
import { useUserStore } from "@app/store/useUserStore";
import type { BootstrapContext } from "../types";

/**
 * Атомарно применяет данные bootstrap в user/reference stores.
 */
export function commitToStores(ctx: BootstrapContext): void {
    if (ctx.currentUser == null) {
        throw new Error("Bootstrap: отсутствуют данные пользователя");
    }

    useUserStore.getState().setUserData({
        currentUser: ctx.currentUser,
        labouring: ctx.labouring ?? null,
    });

    if (ctx.divisionTypes != null) {
        useReferenceStore.getState().setDivisionTypes(ctx.divisionTypes);
    }

    if (ctx.boTypes != null) {
        useReferenceStore.getState().setBoTypes(ctx.boTypes);
    }

    if (ctx.soTypes != null) {
        useReferenceStore.getState().setSoTypes(ctx.soTypes);
    }
}
